import { FiArrowLeft } from "react-icons/fi";
import { useSearchParams } from "react-router";

export default function SettingsMobileHeader({ title }) {
  const [, setParams] = useSearchParams();
  return <header className="settings-mobile-heading">
    <button type="button" aria-label="Back to settings" title="Back to settings" onClick={() => setParams(previous => {
      const next = new URLSearchParams(previous); next.delete("setting"); return next;
    })}><FiArrowLeft aria-hidden="true" /></button>
    {title && <h1 className="text-xl font-semibold">{title}</h1>}
  </header>;
}
